<template>
  <div class="qna-list-wrapper">
    <Alert
      type="warning"
      style="margin: 20px 20px;"
      v-if="!webcast.qnaShowQuestions"
      show-icon
    >{{$t('hide_questions')}}</Alert>
    <ul id="qna-list" class="qna-list" v-if="qnaItems.length && webcast.qnaShowQuestions">
      <li class="qna-item" v-for="qna in qnaItems">
        <!-- qna-header -->
        <div class="qna-item-header">
          <!-- qna-person-info -->
          <div class="qna-item-person">
            <span class="qna-item-person-name">{{ qna.name }}</span>
            <span class="qna-item-person-location">{{ qna.location }}</span>
          </div>

          <div class="qna-item-created" style="font-size:12px;">
            <span>{{ qna.createdAt | moment('HH:mm') }}</span>
          </div>
        </div>

        <!-- .qna-body -->
        <div class="qna-item-body">{{ qna.text }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from "body-scroll-lock";

export default {
  computed: {
    ...mapGetters("qna", {
      findQuestionsInStore: "find"
    }),
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    qnaItems() {
      return this.findQuestionsInStore({
        query: {
          webcastId: this.webcast._id,
          isApproved: true,
          bucket: "inbox",
          $limit: 1000,
          $sort: { updatedAt: 1 }
        }
      }).data;
    }
  },
  watch: {
    qnaItems() {
      this.scrollToListBottom();
    }
  },
  methods: {
    ...mapActions("qna", {
      questionList: "find"
    }),
    scrollToListBottom() {
      let containerEl = document.getElementsByClassName("qna-list-wrapper")[0];
      let listEl = document.getElementsByClassName("qna-list")[0];

      if (listEl) {
        setTimeout(() => {
          listEl.scrollTop = listEl.scrollHeight;
        }, 100);
      }
    }
  },
  created() {
    this.questionList({
      query: {
        webcastId: this.webcast._id
      }
    }).then(response => {
      let listEl = document.getElementsByClassName("qna-list")[0];
      disableBodyScroll(listEl);
      this.scrollToListBottom();
    });
  },
  destroyed() {
    let listEl = document.getElementsByClassName("qna-list")[0];
    enableBodyScroll(listEl);
  }
};
</script>

<style lang="less" scoped>
.qna-list-wrapper {
  overflow: hidden;
  //height: 100%;
  width: 100%;
  //padding-top: 20px;
  //padding-bottom: 115px;
  height: calc(100vh - 230px);
  position: relative;
  z-index: 2000;
  //height: 100%;

  @media screen and (max-width: 992px) {
    height: ~"calc(100vh - 56.25vh + 82px)";
    //246
    //596
  }

  textarea.ivu-input {
    height: 1em !important;
  }
}

.qna {
  &-list {
    font-size: 14px;
    overflow-y: scroll;
    height: 100%;
    list-style: none;
    padding-left: 10px;
    padding-bottom: 10px;

    position: absolute;
    bottom: 0;
    width: 100%;
    -webkit-overflow-scrolling: touch;

    .qna-item {
      margin-left: 15px;
      margin-right: 15px;
      margin-top: 8px;
      margin-bottom: 8px;
      &-header {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .qna-item-person {
          &-name {
            color: #367db8;
            &--action {
              font-size: 14px;
              font-weight: bold;
              color: #373c46;
            }
          }

          &-location {
            color: #808695;
            &--action {
              font-size: 14px;
              color: #777777;
            }
          }
        }
      }
    }
  }
}
</style>
